<template>
    <div>
        <header-page
                @goToFilteredArticlePage="goToFilteredArticlePage"
        ></header-page>
        <div
                v-if="rubrics && articles"
                class="body_zone position-relative separator-t-g2 p-b-32 p-t-16 p-r-20 p-l-20"
        >
            <div class="d-flex justify-content-center">
                <div class="col-md-10 col-lg-10 col-xl-8 col-xxl-8">
                    <div class="row">
                        <div
                                v-if="viewStates.show_preloader_article_spinner"
                                class="col-lg-9 p-b-32 loader_spinner d-flex justify-content-center bg-white align-items-center"
                        >
                            <div class="spinner-border"></div>
                        </div>
                        <div
                                v-else
                                v-html="getArticleContent"
                                class="help_page_content col-lg-9 p-b-32"
                        >
                        </div>
                        <div class="col-lg-3 p-b-32">
                            <div
                                    v-if="rubric_articles"
                            >
                                <div class="css_StyleText16 m-b-16">{{LS("Статьи в этом разделе")}}:</div>
                                <div class="list_other_articles list-group">
                                    <router-link
                                            v-for="article in rubric_articles"
                                            :key="article.id"
                                            :to="`article?r=${article.rubric_id}&a=${article.id}`"
                                            custom v-slot="{ navigate }"
                                    >
                                        <a
                                                @click="navigate"
                                                class="list-group-item css_StyleText21 list-group-item-action style_cursor"
                                                :class="{active: article.id == $route.query.a}"
                                                aria-current="true"
                                        >{{article.content_by_lang.title}}</a>
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <back-to-top />
        </div>
        <footer-page />
    </div>
</template>

<script>
import { computed/*, onBeforeUnmount, reactive, ref, watch, onBeforeMount,*/ } from 'vue'
import {useRouter, onBeforeRouteUpdate, useRoute} from 'vue-router'
import { storeToRefs } from 'pinia'
import HeaderPage from "../../shared/components/HeaderPage";
import BackToTop from "./components/BackToTop";
import FooterPage from "../../shared/components/FooterPage";
import {useClientStorage, useRubricArticleStore, useStatesStorage} from "@/stores/store";
import {InitArticle} from "@/shared/services/init";
import {LS} from "@/shared/services/translate";

export default {
    props: {},
    setup() {
        const rubricArticleStore = useRubricArticleStore();

        const {
            rubric_id,
            article_id,
            rubrics,
            articles,
            article,
            nav_rubric_name,
            rubric_articles,
            nav_article_name
        } = storeToRefs(rubricArticleStore);

        const statesStorage = useStatesStorage();
        const { viewStates } = storeToRefs(statesStorage);

        const route = useRoute();

        const router = useRouter();

        const clientStorage = useClientStorage();
        const lang = clientStorage.clientObj.lang;

        const getArticleContent = computed(() => {
            return article.value && article.value.content_lang ? article.value.content_lang[lang].content : '';
        });

        const goToFilteredArticlePage = (new_filter_text) => {
            router.push({name: 'filtered-articles', params: {filter_text: new_filter_text}})
        };

        onBeforeRouteUpdate((to) => {
            useRubricArticleStore().updateRouteQuery(to.query.r, to.query.a);
            InitArticle(rubric_id.value, article_id.value, to);
        });

        InitArticle(rubric_id.value, article_id.value, route);

        return {
            viewStates,
            rubrics,
            articles,
            getArticleContent,
            rubric_articles,
            nav_rubric_name,
            nav_article_name,
            goToFilteredArticlePage,
            LS
        }
    },
    components: {BackToTop, HeaderPage, FooterPage}
}
</script>

<style scoped>
  .list_other_articles .list-group-item{
     padding: 16px;
  }
  .list_other_articles .list-group-item.active{
      background-color: #5199ff;
      border: none;

  }
</style>